import Units from "../../../utils/Units";
import StaticAxis from "../axes/StaticAxis";
import Day from "../axes/Day";
import Config from "../../../Config";
import Time from "../axes/Time";

let LeafHydricState = {
    type: "line",
    label: "Hydric State",
    fill: false,
    lineTension: 0,
    colorPalette: 15,
    borderWidth:0,
    showLine:false,
    spanGaps: false,
    zIndex:999,

    pointStyle: "circle",
    pointRadius:12,
    pointHoverRadius:14,
    pointBorderWidth:0,
    pointBackgroundColor: Config.colorPalette[16]['stroke'],

    valueModify: function (point) {
        let hydricState = point['v'].substr(0,1);

        /**Hydric state ok*/
        if (hydricState === '1') {
            return {
                pointStyle: 'circle',
                pointRadius:6,
                pointBackgroundColor: Config.colorPalette[7]['stroke']
            };
        } else if (hydricState === '2') {
            return {
                pointStyle: 'triangle',
                pointRadius:12,
                pointBackgroundColor: Config.colorPalette[17]['stroke']
            };
        } else if (hydricState === '3') {
            return {
                pointStyle: 'triangle',
                pointRadius:12,
                pointBackgroundColor: Config.colorPalette[6]['stroke']
            };
        }

        return {
            pointStyle: 'circle',
            pointBackgroundColor: Config.colorPalette[15]['stroke']
        };
    },

    /** show allways at 80% position*/
    dataTransformCallback: function(time, channelValue, dataSets) {
        if (null !== channelValue) {
            return 9;
        }

        return null;
    },

    /**show real string value*/
    tooltipLabelValueCallback: (value, point) => {
        return point['v'];
    },

    yAxis:StaticAxis,
    xAxis:Time
};

export default LeafHydricState;



// WEBPACK FOOTER //
// ./src/components/chart/channels/LeafHydricState.js